import { Checkbox, Typography } from 'antd';
import './ReportsPointRow.less';
import { ApiGeometry } from '../../../models/Geometries';
import { truncateStringEllipsis } from '../../../utils/functions';
import { getCategoriaPunto } from '../../../utils/categorias_punto.constant';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { ReactComponent as Images } from '../../../res/svg/images.svg';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { selectPoint, unselectPoint } from '../../../store/slice/reportsSlice';

const { Title, Text } = Typography;


interface TableProps {
  points: ApiGeometry[];
}


interface Props {
  point: ApiGeometry;
}

export function ReportsPointTable({ points }: TableProps) {
  const [commonWidth, setCommonWidth] = useState(0);
  const tableRef = useRef<HTMLTableElement | null>();

  useEffect(() => {
    if (tableRef) {
      setCommonWidth(tableRef.current?.clientWidth ?? 0);
    }
  }, [tableRef]);

  const colwidth = (commonWidth - 590) / 4;

  return (
    <table ref={e => tableRef.current = e}>
      <colgroup>
        <col style={{ width: 100 }} />
        <col style={{ width: 300 }} />
        <col style={{ width: colwidth }} />
        <col style={{ width: colwidth }} />
        <col style={{ width: colwidth }} />
        <col style={{ width: colwidth }} />
        <col style={{ width: 110 }} />
        <col style={{ width: 80 }} />
      </colgroup>
      {points.map(point => (
        <tbody key={point.id}>
          <ReportsPointHeaderRow />
          <ReportsPointDataRow point={point} />
        </tbody>
      ))}
    </table>
  );
}


export function ReportsPointHeaderRow() {

  return (
    <tr className={'at-reports-point-row__header-row'}>
      <th />
      <th>
        Título
      </th>
      <th>
        Descripción
      </th>
      <th>
        Categoría
      </th>
      <th>
        N° de Acta
      </th>
      <th>
        N° de Expediente
      </th>
      <th>
        Fecha
      </th>
      <th>
        Fotos
      </th>
    </tr>
  );
}

export function ReportsPointDataRow({ point }: Props) {

  const dispatch = useAppDispatch();
  const pointsId: Set<number> = useAppSelector(state => state.reports.pointsIdsSelected);

  return (
    <tr className={'at-reports-point-row__data-row'}>
      <td style={{
        paddingLeft: 52,
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center',
          position: 'relative',
        }}>
          <Checkbox checked={pointsId.has(point.id)}
                    onClick={e => {
                      dispatch(pointsId.has(point.id) ? unselectPoint(point) : selectPoint(point));
                    }}
                    style={{ top: -32, position: 'absolute' }} />
        </div>
      </td>
      <td>
        {point.titulo}
      </td>
      <td>
        {truncateStringEllipsis(point.descripcion, 42)}
      </td>
      <td>
        {point.categoria ? getCategoriaPunto(point.categoria) : '-'}
      </td>
      <td>
        {point.numeroActa ? point.numeroActa : '-'}
      </td>
      <td>
        {point.numExp ? point.numExp : '-'}
      </td>
      <td>
        {moment(point.createdAt).format('DD/MM/YYYY')}
      </td>
      <td>
        {point.adjuntos?.length ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Images /> <span style={{ marginLeft: 4 }}>{point.adjuntos?.length}</span>
          </div>
        ) : '-'}
      </td>
    </tr>
  );
}
